import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const ContainerFlex = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;
